import { GetterTree } from "vuex";
import { AuthState } from "./types";
import { RootState } from "@/store/modules/general/types";

type AuthGetterTree = GetterTree<AuthState, RootState>;

export const getters: AuthGetterTree = {
  isLogged(state: AuthState): boolean {
    return state.isLogged;
  },
  resetPassword(state: AuthState): boolean {
    if(state.usuario != null) return state.usuario.resetPassword
    return false;
  },
  getToken(state: AuthState): string {
    if (state.usuario != null) return state.usuario.token;
    else return "";
  },
};
